import React from 'react';

import { VariantProps, tv } from './utils/cn';

const styles = tv({
  base: 'inline-flex items-center justify-center font-medium whitespace-nowrap',
  variants: {
    size: {
      xs: 'h-6 gap-1 rounded-md px-2 text-3xs',
      s: 'h-7 gap-1.5 rounded-md px-2.5 text-xs',
      m: 'h-7.5 gap-2 rounded-lg p-3 text-sm',
      l: 'h-8.5 gap-3 rounded-lg p-3 text-md',
    },
    pill: {
      true: 'rounded-full',
    },
    color: {
      gray: 'bg-bg-gray-strong text-text-gray-strong',
      lightblue: 'bg-bg-lightblue-strong text-text-lightblue-strong',
      lightgreen: 'bg-bg-lightgreen-strong text-text-lightgreen-strong',
      orange: 'bg-bg-orange-strong text-text-orange-strong',
      purple: 'bg-bg-purple-strong text-text-purple-strong',
      teal: 'bg-bg-teal-strong text-text-teal-strong',
      yellow: 'bg-bg-yellow-strong text-text-yellow-strong',
      negative: 'bg-bg-negative-strong-primary text-text-negative-strong',
      warning: 'bg-bg-warning-strong-primary text-text-warning-strong',
      positive: 'bg-bg-positive-strong-primary text-text-positive-strong',
      info: 'bg-bg-info-strong-primary text-text-info-strong',
      insights: 'bg-bg-insights-strong-primary text-text-insights-strong',
    },
    subtle: {
      true: '',
    },
  },
  compoundVariants: [
    {
      color: 'gray',
      subtle: true,
      className: 'bg-bg-gray-subtle text-text-gray-subtle',
    },
    {
      color: 'lightblue',
      subtle: true,
      className: 'bg-bg-lightblue-subtle text-text-lightblue-subtle',
    },
    {
      color: 'lightgreen',
      subtle: true,
      className: 'bg-bg-lightgreen-subtle text-text-lightgreen-subtle',
    },
    {
      color: 'orange',
      subtle: true,
      className: 'bg-bg-orange-subtle text-text-orange-subtle',
    },
    {
      color: 'purple',
      subtle: true,
      className: 'bg-bg-purple-subtle text-text-purple-subtle',
    },
    {
      color: 'teal',
      subtle: true,
      className: 'bg-bg-teal-subtle text-text-teal-subtle',
    },
    {
      color: 'yellow',
      subtle: true,
      className: 'bg-bg-yellow-subtle text-text-yellow-subtle',
    },
    {
      color: 'negative',
      subtle: true,
      className: 'bg-bg-negative-subtle text-text-negative-subtle',
    },
    {
      color: 'warning',
      subtle: true,
      className: 'bg-bg-warning-subtle text-text-warning-subtle',
    },
    {
      color: 'positive',
      subtle: true,
      className: 'bg-bg-positive-subtle text-text-positive-subtle',
    },
    {
      color: 'info',
      subtle: true,
      className: 'bg-bg-info-subtle text-text-info-subtle',
    },
    {
      color: 'insights',
      subtle: true,
      className: 'bg-bg-insights-subtle text-text-insights-subtle',
    },
  ],
  defaultVariants: {
    color: 'gray',
    size: 'm',
    subtle: true,
  },
});

export type TagProps = VariantProps<typeof styles> & {
  label: string;
  className?: string;
  children?: React.ReactNode;
};

export const Tag = React.forwardRef<HTMLDivElement, TagProps>(
  ({ pill, size, color, label, className, children, subtle }, ref) => {
    const classes = styles({ pill, size, color, className, subtle });

    return (
      <div className={classes} ref={ref}>
        <p>{label}</p>
        {children}
      </div>
    );
  },
);
